import { render, staticRenderFns } from "./move.vue?vue&type=template&id=58e438f8&"
import script from "./js/move.js?vue&type=script&lang=js&"
export * from "./js/move.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports